/*
 * @Author: your name
 * @Date: 2020-09-22 18:41:51
 * @LastEditTime: 2023-03-13 18:16:12
 * @LastEditors: fangteng fangteng@yaomaitong.cn
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/utils/storage.js
 */
import Cookies from 'js-cookie'
const TokenKey = 'token'

export function getToken() {
	return getLocalStorage(TokenKey) || ''
}

export function setToken(token) {
	setLocalStorage(TokenKey, token)
}

export function removeToken() {
	removeLocalStorage(TokenKey)
}
export function removeUserValidCount() {
	removeLocalStorage('__valid_count')
}
export function getUserValidCount() {
	return getLocalStorage('__valid_count')
}
export function saveUserValidCount(_valid_count = 0) {
	setLocalStorage('__valid_count',_valid_count)
}
export function setSessionStorage (key, val) {
  window.sessionStorage.setItem(key, val)
}
export function removeSessionStorage (key) {
  window.sessionStorage.removeItem(key)
}
export function getSessionStorage (key) {
  return window.sessionStorage.getItem(key)
}

export function setLocalStorage(key, value) {
	if (window.localStorage) {
		window.localStorage.setItem(key, value)
	} else {
		Cookies.set(key, value, { expires: 360, path: '/', domain: document.domain })
	}
}
export function getLocalStorage(key) {
	if (window.localStorage) {
		return window.localStorage.getItem(key)
	}
		return Cookies.get(key)

}

export function removeLocalStorage(key) {
	if (window.localStorage) {
		window.localStorage.removeItem(key)
	} else {
		Cookies.remove(key, { path: '/', domain: document.domain })
	}
}

export function saveRecordTime(viewRecordId, current = 0) {			// 保存视频观看时间段
	if (!current) return
	setLocalStorage(`${viewRecordId}_recordtime`, current)
}

export function getRecordTime(viewRecordId = '', videoId) {			// 读取视频观看时间段
	return getLocalStorage(`${viewRecordId}_recordtime`)
}

export function clearRecordTime(viewRecordId) {
	removeLocalStorage(`${viewRecordId}_recordtime`)
}

export function getDoctorId() {
	let token = getToken()
	return token?.split('_')[1] || ''

}

export function saveShareId(id) {
	setLocalStorage('shareId',id)
}

export function getShareId() {
	return getLocalStorage('shareId')
}

export function removeShareId() {
	return removeLocalStorage('shareId')
}

export function saveRecallDialogStatus(key = 'user_recall_dialog_status') {
	setLocalStorage(key,true)
}

export function getRecallDialogStatus(key = 'user_recall_dialog_status') {
	return getLocalStorage(key)
}
